// Configuration de l'API basée sur l'environnement
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

console.log('🌐 Environnement:', process.env.REACT_APP_ENV);
console.log('🔗 API URL:', API_BASE_URL);

// Timeout de 15 minutes (900000ms) pour les requêtes longues avec beaucoup de données
const API_TIMEOUT = 900000;

export const fetchPlanification = async (dateDebut, dateFin) => {
  const url = `${API_BASE_URL}/planification?dateDebut=${dateDebut}&dateFin=${dateFin}`;
  console.log('Appel API URL:', url);
  console.log('⏳ Attention: Cette requête peut prendre jusqu\'à 15 minutes pour les grandes périodes...');

  // Créer un AbortController pour gérer le timeout
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT);

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      mode: 'cors', // Activer CORS explicitement
      credentials: 'include', // Inclure les credentials si nécessaire
      signal: controller.signal,
    });

    clearTimeout(timeoutId);
    console.log('Réponse API status:', response.status);
    console.log('Réponse API headers:', response.headers.get('content-type'));

    if (!response.ok) {
      // Essayer de lire le corps de la réponse pour plus de détails
      const contentType = response.headers.get('content-type');
      
      if (contentType && contentType.includes('application/json')) {
        const errorData = await response.json();
        console.error('Erreur JSON:', errorData);
        throw new Error(errorData.message || `Erreur HTTP: ${response.status}`);
      } else {
        // Si c'est du HTML ou autre, lire comme texte
        const errorText = await response.text();
        console.error('Erreur (non-JSON):', errorText.substring(0, 500));
        
        if (response.status === 404) {
          throw new Error('Aucune donnée trouvée pour cette période');
        }
        if (response.status === 500) {
          throw new Error('Erreur serveur. Vérifiez les logs du backend');
        }
        if (response.status === 400) {
          throw new Error('Format de date invalide. Vérifiez les paramètres');
        }
        throw new Error(`Erreur HTTP ${response.status}: ${errorText.substring(0, 100)}`);
      }
    }

    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      console.error('Réponse non-JSON reçue:', text.substring(0, 500));
      throw new Error('Le serveur a retourné une réponse invalide (HTML au lieu de JSON). Vérifiez l\'URL de l\'API.');
    }

    const data = await response.json();
    console.log('✅ Données reçues avec succès');
    console.log('Nombre de groupes:', Object.keys(data.hierarchie || {}).length);

    if (!data || !data.hierarchie) {
      throw new Error('Format de données invalide: hierarchie manquante');
    }

    return data;
  } catch (error) {
    clearTimeout(timeoutId);
    console.error('❌ Erreur lors de l\'appel API:', error);
    
    if (error.name === 'AbortError') {
      throw new Error('La requête a pris trop de temps (plus de 15 minutes). Essayez avec une période plus courte.');
    }
    
    if (error.name === 'TypeError' && error.message === 'Failed to fetch') {
      throw new Error(`Impossible de se connecter au serveur. Vérifiez que l'API est démarrée sur ${API_BASE_URL}`);
    }
    
    throw error;
  }
};
